import { helper } from '@ember/component/helper';

export const MODEL_ICONS = {
  'accessify': 'model-accessify',
  'a11y-quickscan': 'model-a11y-quickscan',
  'a11y-scanner': 'model-a11y-scanner',
  'a11y-report': 'model-a11y-report',
  'action': 'model-action',
  'administration': 'model-administration',
  'artists-and-products': 'model-artists-and-products',
  'article': 'model-article',
  'articles': 'model-article',
  'artist': 'model-artist',
  'artists': 'model-artist',
  'asset-format': 'model-asset-format',
  'asset-token-config': 'model-asset-token-config',
  'asset': 'model-assets',
  'assets': 'model-assets',
  'audioplayer': 'model-audioplayer',
  'calendar-event': 'model-calendar-event',
  'categories': 'model-categories',
  'category': 'model-categories',
  'channel': 'model-channel',
  'collection': 'model-content-collection',
  'collections': 'model-content-collection',
  'content': 'model-content',
  'coop-partner': 'model-coop-partner',
  'customer-support': 'model-customer-support',
  'dashboard': 'model-dashboard',
  'digital-order-config': 'model-digital-order-config',
  'd2c': 'model-d2c',
  'division': 'model-division',
  'domain': 'model-domain',
  'events': 'model-events',
  'frontend-user': 'model-frontend-user',
  'hero-header': 'model-hero-header',
  'html': 'model-html',
  'job': 'model-jobs',
  'jobs': 'model-jobs',
  'label': 'model-label',
  'link-pattern': 'model-link-pattern',
  'link': 'model-link',
  'live-event': 'model-live-event',
  'live-partner': 'model-live-partner',
  'login': 'model-login',
  'media-embed': 'model-media-embed',
  'media-event': 'model-media-event',
  'media-partner': 'model-media-partner',
  'mlp-add-to-wallet': 'model-mlp-add-to-wallet',
  'mlp-column': 'model-mlp-column',
  'mlp-countdown': 'model-mlp-countdown',
  'mlp-download-link-form': 'model-mlp-download-link-form',
  'mlp-group': 'model-mlp-group',
  'mlp-live-event-feed': 'model-mlp-live-event-feed',
  'mlp-news-feed': 'model-mlp-news-feed',
  'mlp-page': 'model-page-builder',
  'mlp-product-feed': 'model-mlp-product-feed',
  'mlp-row': 'model-mlp-row',
  'mlp-slider': 'model-mlp-slider',
  'mlp-stage-plus-stream': 'model-mlp-stage-plus-stream',
  'mlp-text': 'model-mlp-text',
  'mlp-voucher': 'model-mlp-voucher',
  'mlp-zatap': 'model-mlp-zatap',
  'mlp': 'model-page-builder',
  'newsletter': 'model-newsletter',
  'newsletter-config': 'model-newsletter-config',
  'organization': 'model-organization',
  'partners': 'model-partners',
  'person': 'model-person',
  'product-element': 'model-product-element',
  'product-family': 'model-product-family',
  'product-track': 'model-product-track',
  'product-work': 'model-product-work',
  'product': 'model-product',
  'products': 'model-product',
  'section': 'model-section',
  'sftp-user': 'model-sftp-user',
  'shopify-store': 'model-shopify-store',
  'contest': 'model-contest',
  'short-url': 'model-short-url',
  'short-urls-and-links': 'model-short-urls-and-links',
  'spacer': 'model-spacer',
  'story': 'model-story',
  'taxon': 'model-taxon',
  'taxonomies': 'model-taxonomies',
  'taxonomy': 'model-taxonomies',
  'teaser': 'model-teaser',
  'teasers': 'model-teaser',
  'tool-itunes-ids-uploader': 'model-tool-itunes-ids-uploader',
  'tool-itunes-import': 'model-tool-itunes-import',
  'tool-merge-artists': 'model-tool-merge-artists',
  'tool-mmc-importer': 'model-tool-mmc-importer',
  'tool-reset-voucher': 'model-tool-reset-voucher',
  'trade-partner': 'model-trade-partner',
  'url-alias': 'model-url-alias',
  'user-role': 'model-user-role',
  'user': 'model-user',
  'vhost': 'model-vhost',
  'web-series': 'model-web-series',
  'quick-access': 'model-quick-access',
};

export function modelIcon([recordType]) {
  const icon = MODEL_ICONS[recordType];

  return icon?.replace(/^model-/, '');
}

export function modelIconAssetPath(params) {
  const icon = modelIcon(params);

  if (!icon) {
    return;
  }

  return `/assets/icons/models/${icon}.svg`;
}

export default helper(modelIcon);
